import { ImpulseElement, registerElement, target } from '@ambiki/impulse';
import AwcAutocompleteElement from '@ambiki/impulse-view-components/dist/elements/autocomplete';
import showToast from 'lib/toast_notification';
import type AjaxPartialElement from 'schedules/elements/ajax_partial_element';

@registerElement('manage-user-plan')
export default class ManageUserPlanElement extends ImpulseElement {
  @target() form: HTMLFormElement;
  @target() priceSelect?: AwcAutocompleteElement;
  @target() checkbox?: HTMLInputElement;

  private priceSelectValue = '';
  private checkboxValue = false;

  connected() {
    this.priceSelectValue = this.priceSelect?.value || '';
    this.checkboxValue = this.checkbox?.checked || false;
  }

  handlePlanChange(event: CustomEvent<{ target: HTMLElement }>) {
    // TODO: Remove this once autocomplete supports `selected` event.
    if (this.priceSelectValue === event.detail.target.getAttribute('value')) return;
    this.priceSelectValue = event.detail.target.getAttribute('value') || '';
    this.submitForm();
  }

  submitForm() {
    this.form.requestSubmit();
  }

  // Inform other elements about the seat assignment.
  handleSwitchSuccess(event: Event) {
    // @ts-expect-error an array of responses
    const detail = event.detail[0];
    this.emit('change', { detail });
    this.manageSeatPartial?.fetch();
    showToast('Seat assigned.');
  }

  handlePlanError(event: Event) {
    // @ts-expect-error an array of responses
    const message = this.getErrorMessage(event.detail[0].message);
    showToast(message, { type: 'error', delay: 5000 });
    // Fallback to Basic plan because there aren't any seats available.
    this.priceSelect?.setValue('Basic plan', 'Basic plan');
    this.manageSeatPartial?.fetch();
    this.priceSelectValue = '';
  }

  handleAddonError(event: Event) {
    // @ts-expect-error an array of responses
    const message = this.getErrorMessage(event.detail[0].message);
    showToast(message, { type: 'error', delay: 5000 });
    this.manageSeatPartial?.fetch();
    if (this.checkbox) {
      this.checkbox.checked = this.checkboxValue;
    }
  }

  private getErrorMessage(message: unknown) {
    return message || 'An error occurred';
  }

  private get manageSeatPartial() {
    return document.querySelector<AjaxPartialElement>('#manage_seat_modal_partial');
  }
}
